"use client";

import Image from "next/image";
// import { useCounselorTeamMembers } from "@/hooks/useCounselorTeamMembers";
import { teamMembers } from "@/lib/teamMembers";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface TeamAvatarStackProps {
  maxVisible?: number;
  sizeClassName?: string;
  hiddenFromIndex?: number;
  hiddenSizeClassName?: string;
  className?: string;
  avatarClassName?: string;
}

const TeamAvatarStack = ({
  maxVisible = 6,
  sizeClassName = "size-[40px] sm:size-[48px] md:size-[58px]",
  hiddenFromIndex = 4,
  hiddenSizeClassName = "size-[58px]",
  className = "flex -space-x-2",
  avatarClassName = "border-[2px] border-white bg-slate-200",
}: TeamAvatarStackProps) => {
  const avatars = teamMembers.map((member) => ({
    src: member.image,
    alt: member.name,
  }));

  const visibleAvatars = avatars.slice(0, maxVisible);

  return (
    <TooltipProvider>
      <div className={className}>
        {visibleAvatars.map((avatar, index) => {
          const isHiddenOnMobile =
            hiddenFromIndex !== undefined && index >= hiddenFromIndex;

          return (
            <Tooltip key={`${avatar.alt}-${index}`}>
              <TooltipTrigger asChild>
                <div
                  className={`relative cursor-pointer overflow-hidden rounded-full ${avatarClassName} ${
                    isHiddenOnMobile
                      ? `hidden md:block ${hiddenSizeClassName}`
                      : sizeClassName
                  }`}
                >
                  <Image
                    src={avatar.src}
                    alt={avatar.alt}
                    fill
                    className="object-cover"
                  />
                </div>
              </TooltipTrigger>
              <TooltipContent>{avatar.alt}</TooltipContent>
            </Tooltip>
          );
        })}
      </div>
    </TooltipProvider>
  );
};

export default TeamAvatarStack;
